module.exports = __webpack_public_path__ + "img/02-buffet.06bd1a6f.svg";